var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6766 11.0617V12.9352L9.37623 12.9352C9.09643 12.9352 8.90716 12.7487 8.90716 12.4662V11.5307C8.90716 11.251 9.09369 11.0617 9.37623 11.0617L19.6766 11.0617Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.621 7.69324L15.2766 7.03763C15.4632 6.8511 15.7457 6.8511 15.9322 7.03763L20.5681 11.6735C20.7546 11.86 20.7546 12.1426 20.5681 12.3291L19.5861 13.3111L14.621 8.3461C14.4345 8.15957 14.4345 7.87977 14.621 7.69324Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5833 10.6888L20.5681 11.6708C20.7546 11.8574 20.7546 12.1399 20.5681 12.3264L15.9322 16.9623C15.7457 17.1488 15.4632 17.1488 15.2766 16.9623L14.621 16.3067C14.4345 16.1202 14.4345 15.8376 14.621 15.6511L19.5833 10.6888ZM12.9483 20.4269V19.4914C12.9483 19.2117 12.7617 19.0224 12.4792 19.0224L5.63184 19.0224C5.35204 19.0224 5.16276 18.8358 5.16276 18.5533L5.16276 5.44394C5.16276 5.16415 5.34929 4.97487 5.63184 4.97487L12.4792 4.97487C12.759 4.97487 12.9483 4.78834 12.9483 4.5058V3.57314C12.9483 3.29334 12.7617 3.10406 12.4792 3.10406L3.76103 3.10406C3.48123 3.10406 3.29196 3.2906 3.29196 3.57314V20.4269C3.29196 20.7066 3.47849 20.8959 3.76103 20.8959L12.4792 20.8959C12.759 20.8932 12.9483 20.7066 12.9483 20.4269Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.0747 6.84844V4.03949L12.9482 4.03949V6.84844C12.9482 7.12824 12.7617 7.31751 12.4792 7.31751L11.5438 7.31751C11.3079 7.31751 11.0747 7.13098 11.0747 6.84844ZM11.0747 19.9578L11.0747 17.1488C11.0747 16.869 11.2612 16.6798 11.5438 16.6798L12.4792 16.6798C12.759 16.6798 12.9482 16.8663 12.9482 17.1488L12.9482 19.9578L11.0747 19.9578Z",
    fill: "#222222"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.bf07a6fee2f2ddb48230cf7c07a9973a.svg";
export { ForwardRef as ReactComponent };